export const checkEmail = (pEmail) => {
    let vCheck = false;

    if (pEmail) {
        if (pEmail.toLowerCase().match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ) && pEmail.toLowerCase().indexOf("@mailinator.com") < 0) {
            vCheck = true;
        }
    }

    return vCheck;
}